module.exports = __webpack_public_path__ + "static/img/39.8a0db15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/39.png
// module id = sA5X
// module chunks = 1